// Import dependencies
import { builderFetch } from '@automator/builder/utils';

// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import recipe builder services
import { getLoopFilter } from '@automator/builder/services/item/loop';

/**
 * Updates a loop filter
 *
 * @param {Number} loopID The loop ID (post ID)
 * @param {Number} loopFilterID The loop filter ID (post ID)
 * @param {String} fields JSON string with the values of the fields
 * @param {String} backup JSON string with data that'll be used if the loop filter is missing in the directory
 * @return {Promise} The apiFetch promise
 */
const updateLoopFilter = ( loopID, loopFilterID, fields, backup = {} ) => {
	// Event name
	const eventName = 'uap/builder/core/item/loop/update-loop-filter';

	// Get the loop filter
	const loopFilter = getLoopFilter( loopID, loopFilterID );

	// If the item is not define, stop here
	if ( isEmpty( loopFilter ) ) {
		throw new Error( `updateLoopFilter: The filter ${ loopFilterID } doesn't exist` );
	}

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: `loop/${ UncannyAutomator._recipe.recipe_id }`,
		method: 'POST',
		data: {
			action: 'update_filter',
			// eslint-disable-next-line camelcase
			loop_id: loopID,
			// eslint-disable-next-line camelcase
			loop_filter_id: loopFilterID,
			fields: fields,
			backup: backup
		},
		snackbar: {
			loading: escapeHTML( __( 'Updating loop filter', 'uncanny-automator' ) ),
			success: escapeHTML( __( 'Loop filter updated successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					loopID: loopID,
					loopFilterID: loopFilterID,
					fields: fields,
					backup: backup
				}
			} ) );
		}

		return response;
	} );
}

export default updateLoopFilter;
